import { TextInput, ClearAfterUnmountWrapper } from 'framework/form';
import { PositionDropdown } from 'domain/shared/employee';

const CreateExpertiseForm = () => {
  return (
    <>
      <TextInput source="name" placeholder="Expertise" isRequired />
      <ClearAfterUnmountWrapper>
        <PositionDropdown source="positionIds" label="Position(s)" multiple isRequired positionValueKey="alias" />
      </ClearAfterUnmountWrapper>
    </>
  );
};

export default CreateExpertiseForm;
